import { render } from "./RegistrationPanel.vue?vue&type=template&id=d432a6ee&scoped=true"
import script from "./RegistrationPanel.vue?vue&type=script&lang=ts"
export * from "./RegistrationPanel.vue?vue&type=script&lang=ts"

import "./RegistrationPanel.vue?vue&type=style&index=0&id=d432a6ee&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-d432a6ee"

export default script